import { ContactInfo } from "./contactInfo";

export class AssetAttributes{
    public primaryContact: ContactInfo;
    public uploader : string;
    public creationDate: Date;
    public versionNo: String[];
    public lastUpdated: Date;
    public productStatus: number;
    public visibility: number;
    public selectedQuality: String;
    public compatibilityWithUnity: String;
    public maintainedUntil: Date;
    public privilegedFilesURL: string[];
    
}